;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import { sanitizeRequestUrlForLogging } from '@workspace/server-request-headers/sanitize-request-url';
import * as Sentry from '@sentry/nextjs';
import type { AnalyticsApp } from '../posthog/types';
import { applyNetworkFailureHandling } from './network-failure';
import { shouldDropThirdPartyOnlyError } from './third-party-error-filter';
import { getSentryInitOptions, isSentryEnabled } from './options';

export function initializeSentry({ app }: { app: AnalyticsApp }): void {
  const options = getSentryInitOptions(app);
  if (!options) return;

  Sentry.init({
    ...options,
    beforeSend(event) {
      if (shouldDropThirdPartyOnlyError(event)) return null;
      return applyNetworkFailureHandling(event);
    },
  });
}

export function captureSentryException(
  error: Error | string,
  captureContext?: { tags?: Record<string, string> }
): void {
  if (!isSentryEnabled()) return;

  const dsn = process.env.SENTRY_DSN ?? process.env.NEXT_PUBLIC_SENTRY_DSN;
  if (!dsn) return;

  Sentry.captureException(error, captureContext);
}

/**
 * Use in App Router `error.tsx` boundaries. RSC failures are already sent via
 * `onRequestError` / `captureRequestError`; re-sending them creates duplicate Slack alerts.
 */
export function captureSentryErrorBoundaryException(error: Error & { digest?: string }): void {
  if (error.digest) return;

  const requestUrl =
    typeof window !== 'undefined' ? sanitizeRequestUrlForLogging(window.location.href) : undefined;
  captureSentryException(error, requestUrl ? { tags: { request_url: requestUrl } } : undefined);
}
